/**
 * Catalogue-status helpers for the families board and the product pane (WSRADM-0049).
 *
 * The server's `catalogueStatus` is the answer; `isCurrent` is only the fallback while the
 * field is absent (older wsr-api) — it is never consulted once `catalogueStatus` is present.
 * `NOT_IN_CATALOGUE` retail items are actively sold: never faded, never hidden.
 */
import type { BoardProduct, CatalogueStatus } from '@/api/dimensions/types';

export type EffectiveStatus = CatalogueStatus;

export function effectiveStatus(p: BoardProduct): EffectiveStatus {
  return p.catalogueStatus ?? (p.isCurrent ? 'CURRENT' : 'RETIRED');
}

/** Hidden when "Show retired" is off, and matched by the Retired quick filter. */
export function isHideableRetired(s: EffectiveStatus): boolean {
  return s === 'RETIRED' || s === 'LEGACY';
}

/** Faded (and muted) on a card / row. NOT_IN_CATALOGUE is never faded. */
export function isFaded(s: EffectiveStatus): boolean {
  return s === 'RETIRED' || s === 'LEGACY';
}
